import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Insights } from './pages/Insights';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8nf5krqvf9m">
      <ScrollToTop data-id="element-1" data-mp="2rknlabz4z8qt" />
      <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-2" data-mp="2rlyr0hc56qkk">
        <Navbar data-id="element-3" data-mp="2mm2mmgzj8x4h" />
        <div className="flex-1" data-id="element-4" data-mp="2mmcbg18ucy8l">
          <Routes data-id="element-5" data-mp="2mndrkk4psax6">
            <Route path="/" element={<Home data-id="element-7" data-mp="31agmqk5ke7hc" />} data-id="element-6" data-mp="2mjpwvhnj9igv" />
            <Route path="/insights" element={<Insights data-id="element-9" data-mp="31c9ygdv1bhw7" />} data-id="element-8" data-mp="31ayqs2ygxpzt" />
            <Route path="/contact" element={<Contact data-id="element-11" data-mp="2wjgu3r3habkn" />} data-id="element-10" data-mp="31cjpm4rtfv3h" />
            <Route path="*" element={<Home data-id="element-13" data-mp="2whx8rm2ytac0" />} data-id="element-12" data-mp="2wj8evsjvuu6a" />
          </Routes>
        </div>
        <Footer data-id="element-14" data-mp="28tmi1bqzgr1g" />
      </div>
    </BrowserRouter>;
}